import { Component, Input, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { FreemodeCarouselItem } from 'src/app/models/freecarouselItem';
import { placeholder } from 'src/app/models/placeholder';
import { Browser } from '@capacitor/browser';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
@Component({
  selector: 'benefit-card',
  templateUrl: './benefit-card.component.html',
  styleUrls: ['./benefit-card.component.scss'],
})
export class BenefitCardComponent implements OnInit {
  @Input() data: FreemodeCarouselItem;
  @Input() baseUrl: string;
  @Input() cityFlag: boolean;
  @Input() landingType: string;
  public placeholder = placeholder;

  constructor(
    private navControl: NavController,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit() {}
  async routeTo(itemData) {
    let link = itemData.redirectURL || itemData.landing_url || itemData.link;
    const bannerType =
      this.landingType || itemData.banner_type || itemData.landingType;
    if (this.baseUrl) {
      link = this.baseUrl + '/' + itemData.id;
    }
    if (link) {
      this.navControl.navigateForward([decodeURIComponent(link)]);
      this.analyticsService.trackUnified('benefit_card_clicked', {
        flow: 'shared',
        outcome: 'success',
        legacy_event_name: 'benefit_card_clicked',
        component: 'benefit-card-component',
        button: [decodeURIComponent(link)],
        itemdata: itemData
      });
    }
  }
}
